import FingerprintJS from '@fingerprintjs/fingerprintjs'

function getFileNameFromUrl(url) {
    const urlObj = new URL(url)
    const pathname = urlObj.pathname
    const segments = pathname.split('/')
    return segments.pop() || '' // 获取最后一个部分，如果为空则返回空字符串
}

export async function getFingerprint() {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    return result.visitorId
}

export async function downloadFileByUrl(href) {
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = href
    a.download = getFileNameFromUrl(href)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

// export async function downloadFileByUrlV1(href) {
//     fetch(href, { mode: 'no-cors' })
//         .then((response) => response.blob())
//         .then((blob) => {
//             const url = window.URL.createObjectURL(blob)
//             const a = document.createElement('a')
//             a.style.display = 'none'
//             a.href = url
//             a.download = getFileNameFromUrl(href)
//             document.body.appendChild(a)
//             a.click()
//             window.URL.revokeObjectURL(url)
//             document.body.removeChild(a)
//         })
//         .catch(() => alert('File download failed.'))
// }
